export const LOGIN_USER = 'auth/LOGIN_USER';
export const LOGOUT = 'auth/LOGOUT';
export const SET_USER_AUTH = 'auth/SET_USER_AUTH';
export const SET_TOKEN = 'auth/SET_TOKEN';
export const RESET_USER = 'auth/RESET_USER';
export const CHECK_USER = 'auth/RESET_USER';
export const SET_ALLOWED_MODULES = 'auth/SET_ALLOWED_MODULES';
export const GET_ALLOWED_MODULES = 'auth/GET_ALLOWED_MODULES';

export default {
	LOGIN_USER,
	LOGOUT,
	SET_USER_AUTH,
	SET_TOKEN,
	RESET_USER,
	CHECK_USER,
	SET_ALLOWED_MODULES,
	GET_ALLOWED_MODULES,
};
